import {doApiGet} from "./Requests";
import {FullPayoutBatch, FullPayoutModuleSummary} from "../types/fullPayoutTypes";
import {PaginationParameters, toQueryParameters} from "./Pagination";
import {PaginatedData} from "../hooks/PaginationHooks";


export const fullPayoutApi = {

    getModules: () =>
        doApiGet<FullPayoutModuleSummary[]>(
            `/api/companies/current/shopmodules/fullpayout`
        ),

    getPayouts: (paginationParameters: PaginationParameters, shopModuleId: number) =>
        doApiGet<PaginatedData<FullPayoutBatch>>(
            `/api/companies/current/shopmodules/fullpayout/${shopModuleId}/payouts?${toQueryParameters(paginationParameters)}`
        ),
};
